<template>
  <div class="content" style="min-height: 100vh">
    <div
      class="background-image-search"
      style="background-image: url(/img/temp/blurred-dark.jpg"
    ></div>
    <!-- /.background-image-search -->

    <base-header class="header--recipe pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <h1>Edit Product</h1>
      </b-row>
    </base-header>
    <b-container
      class="container--md mt--6"
    >
      <div class="add-recipe__container">
        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
      <form class="needs-validation"
            @submit.prevent="handleSubmit(firstFormSubmit)">
        <div class="form-row">
          <b-col md="12">
            <base-input label="Product Name"
                        name="name"
                        type="textarea"
                        placeholder="Product Name"
                        success-message="Looks good!"
                        rules="required"
                        v-model="model.name">
            </base-input>
          </b-col>
          <b-col md="12">
            <base-input label="Product Description"
                        name="description"
                        type="textarea"
                        placeholder="Product Description"
                        success-message="Looks good!"
                        rules="required"
                        v-model="model.description">
            </base-input>
          </b-col>
          <b-col md="2">
            <label class="form-control-label">
              Active?
            </label><br />
            <base-switch label="Is Active?"
                    name="isActive"
                    class="mr-1" 
                    on-text="Yes" 
                    off-text="No" 
                    v-model="model.isActive">
            </base-switch>
          </b-col>
          <b-col md="12">
             <div class="dropzone-area">
                <dropzone-file-upload
                  v-model="model.dropzone"
                  single
                />
             </div>
          </b-col>
        </div>
        <base-button type="primary" native-type="submit">Save Product</base-button>
      </form>
    </validation-observer>
      </div>
    </b-container>
  </div>
</template>
<script>
  import { Select, Option } from 'element-ui'
  import DropzoneFileUpload from '../../components/Inputs/DropzoneFileUpload.vue';
  import HtmlEditor from '../../components/Inputs/HtmlEditor.vue';
  import Instructions from '../Components/Instructions.vue';
  import { authHeader } from '../../_helpers';
  import axios from 'axios'

  const apiClient = axios.create({
    baseURL: `${process.env.VUE_APP_API_HOSTNAME}/api/products/`,
    withCredentials: false,
    headers: authHeader()
  })

  export default {
    name: "EditProduct",
    components: {
        HtmlEditor,
        DropzoneFileUpload,
        [Select.name]: Select,
        [Option.name]: Option,
        Instructions
    },
    data() {
      return {
        model: {
          id: '',
          name: '',
          iconId: '0215cb06-0ebb-4b17-098d-08d9269dc513',
          icon: '',
          isDietary: false,
          isActive: true,
          isDeleted: false,
          isVisible: true,
        }
      }
    },
    methods: {
      firstFormSubmit() {
        const { dispatch } = this.$store;
        if (this.model.name) {
          try {
              dispatch("products/updateProduct", this.model)
                  .then(response => {
                  this.$notify({verticalAlign: 'top', horizontalAlign: 'right', type: 'success', message: 'Product Updated'});
                  this.$router.push({path: "/products"});
              }).catch(error => {
                  console.log('Something went wrong: ', error);
              });
          } catch (error) {
              console.log("Error: product add", error);
          }
        }
      },
      getProduct(id) {
        return apiClient.get(`${id}`);
      }
    },
    computed: {
    },
    created() {
      this.model.id = this.$route.params.id;
      this.getProduct(this.model.id)
        .then(response => {
          this.model = response.data;
        })
        .catch(error => {
          console.log(error)
        });
    },
    mounted() {
      
    }
  }
</script>
<style>
.shortcut-item.add-collection{
  text-align: left;
  margin-bottom: 30px;
}
</style>
